export const coachDashboardHeaderSiteCoreKeys = {
  dashboardHeaderTitle: "CoachPortal.Dashboard.DashboardHeader",
  addActivityButton: "Dashboard.DashboardHeader.AddActivityButton",
};

export const coachMetricsSiteCoreKeys = {
  coachMetricsTitle: "CoachPortal.Dashboard.CoachMetrics",
  caseloadsVsEngagementCardHeader:
    "Dashboard.CoachMetrics.CaseloadsVsEngagementCardHeader",
  caseloadsVsEngagementCardAssigned:
    "Dashboard.CoachMetrics.CaseloadsVsEngagementCard.Assigned",
  caseloadsVsEngagementCardNoEngagement:
    "Dashboard.CoachMetrics.CaseloadsVsEngagementCard.NoEngagement",
  avgTimeSpentCardHeader: "Dashboard.CoachMetrics.AvgTimeSpentCardHeader",
  avgTimeSpentCardPerParticipant:
    "Dashboard.CoachMetrics.AvgTimeSpentCard.PerParticipant",
  coachingActivitiesCardHeader:
    "Dashboard.CoachMetrics.CoachingActivitiesCardHeader",
  coachingActivitiesCardCompleted:
    "Dashboard.CoachMetrics.CoachingActivitiesCard.Completed",
  coachingActivitiesCardTimeSpent:
    "Dashboard.CoachMetrics.CoachingActivitiesCard.TimeSpent",
  participantsLandedCardHeader:
    "Dashboard.CoachMetrics.ParticipantsLandedCardHeader",
  participantsLandedCardSecuredAJob:
    "Dashboard.CoachMetrics.ParticipantsLandedCard.SecuredAJob",
  periodList: "Dashboard.CoachMetrics.PeriodList",
};

export const myCaseloadsSiteCoreKeys = {
  myCaseloadsTitle: "CoachPortal.Dashboard.MyCaseloads",
  myCaseloadsVsEngagementPopupHeader:
    "Dashboard.MyCaseloads.MyCaseloadsVsEngagementPopupHeader",
  participantsLandedPopupHeader:
    "Dashboard.MyCaseloads.ParticipantsLandedPopupHeader",
  newJoinersTab: "Dashboard.MyCaseloads.NewJoinersTab",
  nearingClosureTab: "Dashboard.MyCaseloads.NearingClosureTab",
  allTab: "Dashboard.MyCaseloads.AllTab",
  assignedTab: "Dashboard.MyCaseloads.AssignedTab",
  notRegisteredTab: "Dashboard.MyCaseloads.NotRegisteredTab",
  noCoachingTab: "Dashboard.MyCaseloads.NoCoachingTab",
  notLoggedTab: "Dashboard.MyCaseloads.NotLoggedTab",
  participantNameTableColumn:
    "Dashboard.MyCaseloads.ParticipantNameTableColumn",
  programTemplateTableColumn:
    "Dashboard.MyCaseloads.ProgramTemplateTableColumn",
  participantStatusTableColumn:
    "Dashboard.MyCaseloads.ParticipantStatusTableColumn",
  nextContactDateTableColumn:
    "Dashboard.MyCaseloads.NextContactDateTableColumn",
  upcomingSessionTableColumn:
    "Dashboard.MyCaseloads.UpcomingSessionTableColumn",
  programEndDateTableColumn: "Dashboard.MyCaseloads.ProgramEndDateTableColumn",
  assignedCoachesTableColumn:
    "Dashboard.MyCaseloads.AssignedCoachesTableColumn",
  participantEmailTableColumn:
    "Dashboard.MyCaseloads.ParticipantEmailTableColumn",
  participantMobileNumberTableColumn:
    "Dashboard.MyCaseloads.ParticipantMobileNumberTableColumn",
  projectManagerTableColumn: "Dashboard.MyCaseloads.ProjectManagerTableColumn",
  countryTableColumn: "Dashboard.MyCaseloads.CountryTableColumn",
  programStartMonthYearTableColumn:
    "Dashboard.MyCaseloads.ProgramStartMonthYearTableColumn",
  actionTableColumn: "Dashboard.MyCaseloads.ActionTableColumn",
  actionTableColumnManage: "Dashboard.MyCaseloads.ActionTableColumn.Manage",
  actionTableColumnAddActivity:
    "Dashboard.MyCaseloads.ActionTableColumn.AddActivity",
  noCaseloadsAvailable: "Dashboard.MyCaseloads.NoCaseloadsAvailable",
  noNearingClosureAvailable: "Dashboard.MyCaseloads.NoNearingClosureAvailable",
  noNewJoinersAvailable: "Dashboard.MyCaseloads.NoNewJoinersAvailable",
  participantStatusList: "Dashboard.MyCaseloads.ParticipantStatusList",
  noAssignedCaseloads: "Dashboard.MyCaseloads.AssignedTab.NoAssignedCaseloads",
  noParticipantsWithRegistrationPending:
    "Dashboard.MyCaseloads.NotRegisteredTab.NoParticipantsWithRegistrationPending",
  noParticipantsWithCoachingPendingForOver30Days:
    "Dashboard.MyCaseloads.NoParticipantsWithCoachingPendingForOver30Days",
  noParticipantsWithLoginPendingForOver30Days:
    "Dashboard.MyCaseloads.NotLoggedTab.NoParticipantsWithLoginPendingForOver30Days",
};

export const myMeetingsSiteCoreKeys = {
  myMeetingsTitle: "CoachPortal.Dashboard.MyMeetings",
  typeDropDown: "Dashboard.MyMeetings.TypeDropDown",
  periodDropDown: "Dashboard.MyMeetings.PeriodDropDown",
  title: "Dashboard.MyMeetings.Title",
  createdDate: "Dashboard.MyMeetings.CreatedDate",
  meetingDuration: "Dashboard.MyMeetings.MeetingDuration",
  meetingDate: "Dashboard.MyMeetings.MeetingDate",
  mode: "Dashboard.MyMeetings.Mode",
  attendees: "Dashboard.MyMeetings.Attendees",
  meetingUpdate: "Dashboard.MyMeetings.MeetingUpdate",
  noMeetingsAvailable: "Dashboard.MyMeetings.NoMeetingsAvailable",
  pastSessionsPeriodList: "Dashboard.MyMeetings.PastSessionsPeriodList",
  sessionsTypeList: "Dashboard.MyMeetings.SessionsTypeList",
  upcomingSessionsPeriodList: "Dashboard.MyMeetings.UpcomingSessionsPeriodList",
  meetingTypeList: "Dashboard.MyMeetings.MeetingTypeList",
};

export const searchParticipantsSearchSectionSiteCoreKeys = {
  searchParticipantsSearchSectionTitle:
    "CoachPortal.SearchParticipants.SearchSection",
  selectSearchTypeHeader:
    "SearchParticipants.SearchSection.SelectSearchTypeHeader",
  myCaseloadsRadioButton:
    "SearchParticipants.SearchSection.MyCaseloadsRadioButton",
  allParticipantsRadioButton:
    "SearchParticipants.SearchSection.AllParticipantsRadioButton",
  participantFirstName: "SearchParticipants.SearchSection.ParticipantFirstName",
  participantFirstNamePlaceholderText:
    "SearchParticipants.SearchSection.ParticipantFirstNamePlaceholderText",
  participantLastName: "SearchParticipants.SearchSection.ParticipantLastName",
  participantLastNamePlaceholderText:
    "SearchParticipants.SearchSection.ParticipantLastNamePlaceholderText",
  programKey: "SearchParticipants.SearchSection.ProgramKey",
  programKeyPlaceholderText:
    "SearchParticipants.SearchSection.ProgramKeyPlaceholderText",
  participantEmail: "SearchParticipants.SearchSection.ParticipantEmail",
  participantEmailPlaceholderText:
    "SearchParticipants.SearchSection.ParticipantEmailPlaceholderText",
  participantMobileNumber:
    "SearchParticipants.SearchSection.ParticipantMobileNumber",
  clientName: "SearchParticipants.SearchSection.ClientName",
  clientNamePlaceholderText:
    "SearchParticipants.SearchSection.ClientNamePlaceholderText",
  coach: "SearchParticipants.SearchSection.CoachDropDown",
  ageingLabel: "SearchParticipants.SearchSection.AgeingDropDown",
  ageingList: "SearchParticipants.SearchSection.AgeingList",
  filterByList: "SearchParticipants.SearchSection.FilterByList",
  contains: "FilterBy.Contains",
  coachTypeDropDown: "SearchParticipants.SearchSection.CoachTypeDropDown",
  participantRefineSearchMessage:
    "SearchParticipants.SearchSection.ParticipantRefineSearchMessage",
  participantStatus: "SearchParticipants.SearchSection.ParticipantStatus",
  participantStatusList:
    "SearchParticipants.SearchSection.ParticipantStatusList",
};

export const searchParticipantsResultsSectionSiteCoreKeys = {
  searchParticipantsResultsSectionTitle:
    "CoachPortal.SearchParticipants.ResultsSection",
  myCaseloadsSectionHeader:
    "SearchParticipants.ResultsSection.MyCaseloadsSectionHeader",
  allParticipantsSectionHeader:
    "SearchParticipants.ResultsSection.AllParticipantsSectionHeader",
  participantNameLabel:
    "SearchParticipants.ResultsSection.ParticipantNameTableColumn",
  programKeyLabel: "SearchParticipants.ResultsSection.ProgramKeyTableColumn",
  nextSessionEventLabel:
    "SearchParticipants.ResultsSection.NextSessionEventTableColumn",
  nextViewLabel: "SearchParticipants.ResultsSection.NextViewTableColumn",
  assignedCoachesLabel:
    "SearchParticipants.ResultsSection.AssignedCoachesTableColumn",
  clientNameLabel: "SearchParticipants.ResultsSection.ClientNameTableColumn",
  programStatusLabel:
    "SearchParticipants.ResultsSection.ProgramStatusTableColumn",
  participantEmailLabel:
    "SearchParticipants.ResultsSection.ParticipantEmailTableColumn",
  participantMobileNumberLabel:
    "SearchParticipants.ResultsSection.ParticipantMobileNumberTableColumn",
  projectManagerLabel:
    "SearchParticipants.ResultsSection.ProjectManagerTableColumn",
  countryLabel: "SearchParticipants.ResultsSection.CountryTableColumn",
  programStartMonthYearLabel:
    "SearchParticipants.ResultsSection.ProgramStartMonthYearTableColumn",
  programEndDateLabel:
    "SearchParticipants.ResultsSection.ProgramEndDateTableColumn",
  actionLabel: "SearchParticipants.ResultsSection.ActionTableColumn",
  programStatusList: "SearchParticipants.ResultsSection.ProgramStatusList",
  manageLabel: "SearchParticipants.ResultsSection.ActionTableColumn.Manage",
  addActivityLabel:
    "SearchParticipants.ResultsSection.ActionTableColumn.AddActivity",
};

export const manageParticipantHeaderSiteCoreKeys = {
  manageParticipantHeaderTitle:
    "CoachPortal.ManageParticipants.ManageParticipantHeader",
  nextContactDate: "ManageParticipants.ManageParticipantHeader.NextContactDate",
  activitiesTile: "ManageParticipants.ManageParticipantHeader.ActivitiesTile",
  activitiesTilePerformed:
    "ManageParticipants.ManageParticipantHeader.ActivitiesTile.Performed",
  sessionsAndEventsTile:
    "ManageParticipants.ManageParticipantHeader.SessionsAndEventsTile",
  sessionsAndEventsTileAttended:
    "ManageParticipants.ManageParticipantHeader.SessionsAndEventsTile.Attended",
  assessmentsTile: "ManageParticipants.ManageParticipantHeader.AssessmentsTile",
  assessmentsTileCompleted:
    "ManageParticipants.ManageParticipantHeader.AssessmentsTile.Completed ",
  programTab: "ManageParticipants.ManageParticipantHeader.ProgramTab",
  participantTab: "ManageParticipants.ManageParticipantHeader.ParticipantTab",
  activityTimelineTab:
    "ManageParticipants.ManageParticipantHeader.ActivityTimelineTab",
  sessionsAndEventsTab:
    "ManageParticipants.ManageParticipantHeader.SessionsAndEventsTab",
  documentsTab: "ManageParticipants.ManageParticipantHeader.DocumentsTab",
  programStatusList:
    "ManageParticipants.ManageParticipantHeader.ProgramStatusList",
  editParticipantHeader:
    "ManageParticipants.ManageParticipantHeader.EditParticipantHeader",
  viewParticipantHeader:
    "ManageParticipants.ManageParticipantHeader.ViewParticipantHeader",
};

export const manageParticipantProgramDetailsSiteCoreKeys = {
  programDetailsTitle: "CoachPortal.ManageParticipants.Program.ProgramDetails",
  programName: "ManageParticipants.ProgramDetails.ProgramName",
  programKey: "ManageParticipants.ProgramDetails.ProgramKey",
  opportunityId: "ManageParticipants.ProgramDetails.OpportunityID",
  productLine: "ManageParticipants.ProgramDetails.ProductLine",
  programTemplate: "ManageParticipants.ProgramDetails.ProgramTemplate",
  nextView: "ManageParticipants.ProgramDetails.NextView",
  nextProgramClass: "ManageParticipants.ProgramDetails.NextProgramClass",
  deliveryCountry: "ManageParticipants.ProgramDetails.DeliveryCountry",
  salesOffice: "ManageParticipants.ProgramDetails.SalesOffice",
  alternateDisplayName:
    "ManageParticipants.ProgramDetails.AlternateDisplayName",
  programEndDate: "ManageParticipants.ProgramDetails.ProgramEndDate",
};

export const manageParticipantOfficeAndContactDetailsSiteCoreKeys = {
  officeAndContactDetailsTitle:
    "CoachPortal.ManageParticipants.Program.OfficeAndContactDetails",
  billingOffice: "ManageParticipants.OfficeAndContactDetails.BillingOffice",
  salesOffice: "ManageParticipants.OfficeAndContactDetails.SalesOffice",
  localClientRelationshipOwner:
    "ManageParticipants.OfficeAndContactDetails.LocalClientRelationshipOwner",
  deliveryOffice: "ManageParticipants.OfficeAndContactDetails.DeliveryOffice",
  billingContact: "ManageParticipants.OfficeAndContactDetails.BillingContact",
  hrContact: "ManageParticipants.OfficeAndContactDetails.HRContact",
  projectManager: "ManageParticipants.OfficeAndContactDetails.ProjectManager",
  coordinator: "ManageParticipants.OfficeAndContactDetails.Coordinator",
  deliveryOfficeList:
    "ManageParticipants.OfficeAndContactDetails.DeliveryOfficeList",
};

export const manageParticipantParticipantInformationSiteCoreKeys = {
  participantInformationTitle:
    "CoachPortal.ManageParticipants.Participant.ParticipantInformation",
  participantName: "ManageParticipants.ParticipantInformation.ParticipantName",
  dateOfBirth: "ManageParticipants.ParticipantInformation.DateOfBirth",
  age: "ManageParticipants.ParticipantInformation.Age",
  gender: "ManageParticipants.ParticipantInformation.Gender",
  telephone: "ManageParticipants.ParticipantInformation.Telephone",
  mobile: "ManageParticipants.ParticipantInformation.Mobile",
  appendPhone: "ManageParticipants.ParticipantInformation.AppendPhone",
  email: "ManageParticipants.ParticipantInformation.Email",
  workEmail: "ManageParticipants.ParticipantInformation.WorkEmail",
  spouseOrPartner: "ManageParticipants.ParticipantInformation.SpouseOrPartner",
  educationLevel: "ManageParticipants.ParticipantInformation.EducationLevel",
  mustStartByDate: "ManageParticipants.ParticipantInformation.MustStartByDate",
  projectedProgramEndDate:
    "ManageParticipants.ParticipantInformation.ProjectedProgramEndDate",
  primaryLanguage: "ManageParticipants.ParticipantInformation.PrimaryLanguage",
  nisId: "ManageParticipants.ParticipantInformation.NISID",
  textSubscribedDate:
    "ManageParticipants.ParticipantInformation.TextSubscribedDate",
  textUnsubscribedDate:
    "ManageParticipants.ParticipantInformation.TextUnsubscribedDate",
  emailUnsubscribedDate:
    "ManageParticipants.ParticipantInformation.EmailUnsubscribedDate",
  educationLevelList:
    "ManageParticipants.ParticipantInformation.EducationLevelList",
  languagesList: "ManageParticipants.ParticipantInformation.LanguagesList",
  prefixList: "ManageParticipants.ParticipantInformation.PrefixList",
  genderList: "ManageParticipants.ParticipantInformation.GenderList",
};

export const manageParticipantAddressDetailsSiteCoreKeys = {
  addressDetailsTitle:
    "CoachPortal.ManageParticipants.Participant.AddressDetails",
  address: "ManageParticipants.AddressDetails.Address",
};

export const manageParticipantOutreachSiteCoreKeys = {
  outreachTitle: "CoachPortal.ManageParticipants.Participant.Outreach",
  eligibility: "ManageParticipants.Outreach.Eligibility",
  outreachEligibleStatus: "ManageParticipants.Outreach.OutreachEligibleStatus",
  primaryManagedStatus: "ManageParticipants.Outreach.PrimaryManagedStatus",
  secondaryManagedStatus: "ManageParticipants.Outreach.SecondaryManagedStatus",
  assignedOutreachConsultant:
    "ManageParticipants.Outreach.AssignedOutreachConsultant",
  notificationDate: "ManageParticipants.Outreach.NotificationDate",
  releaseDate: "ManageParticipants.Outreach.ReleaseDate",
  outreachEligibleDate: "ManageParticipants.Outreach.OutreachEligibleDate",
  notificationSupportDate:
    "ManageParticipants.Outreach.NotificationSupportDate",
  notificationSupportStatus:
    "ManageParticipants.Outreach.NotificationSupportStatus",
  contactWithin24Hours: "ManageParticipants.Outreach.ContactWithin24Hours",
  eligibilityList: "ManageParticipants.Outreach.EligibilityList",
  noOutreachPermittedList:
    "ManageParticipants.Outreach.NoOutreachPermittedList",
  notificationSupportStatusList:
    "ManageParticipants.Outreach.NotificationSupportStatusList",
  outreachEligibleStatusList:
    "ManageParticipants.Outreach.OutreachEligibleStatusList",
  pendingFurtherActionsList:
    "ManageParticipants.Outreach.PendingFurtherActionsList",
  pendingOREList: "ManageParticipants.Outreach.PendingOREList",
  primaryManagedStatusList:
    "ManageParticipants.Outreach.PrimaryManagedStatusList",
};

export const manageParticipantSponsoringEmployerSiteCoreKeys = {
  sponsoringEmployerTitle:
    "CoachPortal.ManageParticipants.Participant.SponsoringEmployer",
  clientName: "ManageParticipants.SponsoringEmployer.ClientName",
  jobTitle: "ManageParticipants.SponsoringEmployer.JobTitle",
  occupationalFunction:
    "ManageParticipants.SponsoringEmployer.OccupationalFunction",
  occupationalFunctionIfOtherSpecify:
    "ManageParticipants.SponsoringEmployer.OccupationalFunctionIfOtherSpecify",
  occupationalLevel: "ManageParticipants.SponsoringEmployer.OccupationalLevel",
  occupationalLevelIfOtherSpecify:
    "ManageParticipants.SponsoringEmployer.OccupationalLevelIfOtherSpecify",
  notificationDate: "ManageParticipants.SponsoringEmployer.NotificationDate",
  totalYearsEmployed:
    "ManageParticipants.SponsoringEmployer.TotalYearsEmployed",
  planPostedDate: "ManageParticipants.SponsoringEmployer.PlanPostedDate",
  datePlanApproved: "ManageParticipants.SponsoringEmployer.DatePlanApproved",
  currentEmploymentStartDate:
    "ManageParticipants.SponsoringEmployer.CurrentEmploymentStartDate",
  targetIndustry: "ManageParticipants.SponsoringEmployer.TargetIndustry",
  bestMatchPreference:
    "ManageParticipants.SponsoringEmployer.BestMatchPreference",
  specialAssignments:
    "ManageParticipants.SponsoringEmployer.SpecialAssignments",
  securityClearance: "ManageParticipants.SponsoringEmployer.SecurityClearance",
  bestMatchPreferenceList:
    "ManageParticipants.SponsoringEmployer.BestMatchPreferenceList",
  occupationalFunctionList:
    "ManageParticipants.SponsoringEmployer.OccupationalFunctionList",
  occupationalLevelList:
    "ManageParticipants.SponsoringEmployer.OccupationalLevelList",
  specialAssignmentsList:
    "ManageParticipants.SponsoringEmployer.SpecialAssignmentsList",
  employeeId: "ManageParticipants.SponsoringEmployer.EmployeeID",
};

export const manageParticipantCareerGoalsSiteCoreKeys = {
  careerGoalsTitle: "CoachPortal.ManageParticipants.Participant.CareerGoals",
  targetJobTitle: "ManageParticipants.CareerGoals.TargetJobTitle",
  targetOccupationalFunction:
    "ManageParticipants.CareerGoals.TargetOccupationalFunction",
  targetOccupationalFunctionIfOthersSpecify:
    "ManageParticipants.CareerGoals.TargetOccupationalFunctionIfOthersSpecify",
  targetOccupationalLevel:
    "ManageParticipants.CareerGoals.TargetOccupationalLevel",
  targetIndustry: "ManageParticipants.CareerGoals.TargetIndustry",
  targetOrganizations: "ManageParticipants.CareerGoals.TargetOrganizations",
  targetJobType: "ManageParticipants.CareerGoals.TargetJobType",
  targetLocation: "ManageParticipants.CareerGoals.TargetLocation",
  skillsKeywords: "ManageParticipants.CareerGoals.SkillsKeywords",
  targetSalaryRange: "ManageParticipants.CareerGoals.TargetSalaryRange",
  technicalSkills: "ManageParticipants.CareerGoals.TechnicalSkills",
  preferences: "ManageParticipants.CareerGoals.Preferences",
  authorisedConnections: "ManageParticipants.CareerGoals.AuthorisedConnections",
  authorisedConnectionsToolTipMessage:
    "ManageParticipants.CareerGoals.AuthorisedConnectionsToolTipMessage",
  experis: "ManageParticipants.CareerGoals.Experis",
  manPowerEngineering: "ManageParticipants.CareerGoals.ManpowerEngineering",
  jeffersonWells: "ManageParticipants.CareerGoals.JeffersonWells",
  rpo: "ManageParticipants.CareerGoals.RPO",
  participantNotSeekingEmployment:
    "ManageParticipants.CareerGoals.ParticipantNotSeekingEmployment",
  participantWillingToWorkRemotely:
    "ManageParticipants.CareerGoals.ParticipantWillingToWorkRemotely",
  openToRelocation: "ManageParticipants.CareerGoals.OpenToRelocation",
  participantWillingToTravelForWork:
    "ManageParticipants.CareerGoals.ParticipantWillingToTravelForWork",
  targetJobTypeList: "ManageParticipants.CareerGoals.TargetJobTypeList",
  targetOccupationalFunctionList:
    "ManageParticipants.CareerGoals.TargetOccupationalFunctionList",
  targetOccupationalLevelList:
    "ManageParticipants.CareerGoals.TargetOccupationalLevelList",
  targetSalaryRangeList: "ManageParticipants.CareerGoals.TargetSalaryRangeList",
  targetIndustryList: "ManageParticipants.CareerGoals.TargetIndustryList",
  targetOccupationalFunctionOther:
    "ManageParticipants.CareerGoals.TargetOccupationalFunctionOther",
};

export const manageParticipantsSessionAndEventsSiteCoreKeys = {
  sessionAndEventsTitle: "CoachPortal.ManageParticipants.SessionsAndEvents",
  typeDropDown: "ManageParticipants.SessionsAndEvents.TypeDropDown",
  periodDropDown: "ManageParticipants.SessionsAndEvents.PeriodDropDown",
  categoryDropDown: "ManageParticipants.SessionsAndEvents.CategoryDropDown",
  title: "ManageParticipants.SessionsAndEvents.Title",
  createdDate: "ManageParticipants.SessionsAndEvents.CreatedDate",
  by: "ManageParticipants.SessionsAndEvents.By",
  meetingDate: "ManageParticipants.SessionsAndEvents.MeetingDate",
  eventDate: "ManageParticipants.SessionsAndEvents.EventDate",
  meetingDuration: "ManageParticipants.SessionsAndEvents.MeetingDuration",
  eventDuration: "ManageParticipants.SessionsAndEvents.EventDuration",
  category: "ManageParticipants.SessionsAndEvents.Category",
  instructorLedTraining:
    "ManageParticipants.SessionsAndEvents.InstructorLedTraining",
  mode: "ManageParticipants.SessionsAndEvents.Mode",
  initiatedBy: "ManageParticipants.SessionsAndEvents.InitiatedBy",
  instructor: "ManageParticipants.SessionsAndEvents.Instructor",
  meetingUpdate: "ManageParticipants.SessionsAndEvents.MeetingUpdate",
  eventStatus: "ManageParticipants.SessionsAndEvents.EventStatus",
  noCoachingSessionsAvailable:
    "ManageParticipants.SessionsAndEvents.NoCoachingSessionsAvailable",
  noEventsAvailable: "ManageParticipants.SessionsAndEvents.NoEventsAvailable",
  pastSessionsAndEventsPeriodList:
    "ManageParticipants.SessionsAndEvents.PastSessionsAndEventsPeriodList",
  sessionsAndEventsCategoryList:
    "ManageParticipants.SessionsAndEvents.SessionsAndEventsCategoryList",
  sessionsAndEventsTypeList:
    "ManageParticipants.SessionsAndEvents.SessionsAndEventsTypeList",
  upcomingSessionsAndEventsPeriodList:
    "ManageParticipants.SessionsAndEvents.UpcomingSessionsAndEventsPeriodList",
  meetingTypeListKey: "ManageParticipants.SessionsAndEvents.MeetingTypeList",
};
